import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { topics } from "@/mocks/topics";

export default function TopicShowcase() {
  return (
    <section className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="热门专题"
        title="把零散线索拼成完整脉络"
        desc="单个爆料只是碎片。专题会把同一类线索按时间线串联起来，让你一次看清事情的来龙去脉。"
        action={{ label: "查看全部专题", to: "/topics" }}
      />

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to="/topics"
            className="group relative overflow-hidden rounded-lg border border-foreground-950/10 bg-foreground-950"
          >
            <div className="h-72 w-full md:h-80">
              <img
                src={topic.cover}
                alt={`${topic.title} - 看料爆料热门专题封面`}
                title={`${topic.title} - 看料爆料专题`}
                className="h-full w-full object-cover opacity-75 transition-opacity duration-500 group-hover:opacity-90"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5">
              <span className="inline-block rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-accent-950">
                {topic.tag} · {topic.count} 条
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-background-50">
                {topic.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-200">{topic.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}